import { render, staticRenderFns } from "./OdontogramsDetails.vue?vue&type=template&id=3a7d4994&scoped=true"
import script from "./OdontogramsDetails.vue?vue&type=script&lang=js"
export * from "./OdontogramsDetails.vue?vue&type=script&lang=js"
import style0 from "./OdontogramsDetails.vue?vue&type=style&index=0&id=3a7d4994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7d4994",
  null
  
)

export default component.exports